import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { SeFeAvatarModule } from 'se-fe-avatar'
import { SeFeLinkModule } from 'se-fe-link'
import { PersonaAvatarGroupComponent } from './persona-avatar-group/persona-avatar-group.component'

@NgModule({
  imports: [
    CommonModule,
    SeFeAvatarModule,
    SeFeLinkModule
  ],
  declarations: [
    PersonaAvatarGroupComponent
  ],
  exports: [
    PersonaAvatarGroupComponent
  ]
})
export class SharedUiPersonaAvatarGroupModule {}
